module.exports = __webpack_public_path__ + "img/lock.851e5df4.svg";